import { render } from "./stockAdjustment.vue?vue&type=template&id=50f034d8"
import script from "./stockAdjustment.vue?vue&type=script&lang=js"
export * from "./stockAdjustment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__